import { Component, HostListener } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ApiService } from "../app/api.service";
import { environment } from "../environments/environment";
import { filter, map, mergeMap } from "rxjs/operators"
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

interface GlobalSearchItem {
  title: string;
  subtitle: string;
  route: string;
  icon: string;
  keywords: string[];
  visible?: () => boolean;
}

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  sidebarCollapsed = false;

  menuDenariosShow = false;

  activeSubmenu: string | null = null;
  activeDcardSubmenu: string | null = null;

  isProduction = environment.production;

  searchTerm = '';
  searchOpen = false;
  searchResults: GlobalSearchItem[] = [];

  constructor(
    public api: ApiService,
    public router: Router,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private activatedRoute: ActivatedRoute
  ) {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),

        map(() => this.activatedRoute),

        map(route => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),

        mergeMap(route => route.data))
      .subscribe(data => {
        this.api.title = data['title'] || '';
        this.api.subtitle = data['subtitle'] || '';

        if (this.esRolPqr) {
          const url = this.router.url.split('?')[0];

          if (url !== '/pqr' && !url.startsWith('/pqr/')) {
            this.router.navigateByUrl('/pqr');
            return;
          }
        }

        this.sidebarCollapsed = this.router.url !== '/dashboard';
      });

    this.matIconRegistry.addSvgIcon(
      'logo-denario',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/img/logoDenarioAzul.svg')
    );
  }

  toggleSidebar(): void {
    this.sidebarCollapsed = !this.sidebarCollapsed;
  }

  menuDenariosShowfun(): void {
    this.menuDenariosShow = !this.menuDenariosShow;
  }

  toggleDcardSubmenu(menu: string): void {
    if (this.activeDcardSubmenu === menu) {
      this.activeDcardSubmenu = null;
    } else {
      this.activeDcardSubmenu = menu;
    }
  }

  toggleSubmenu(menu: string): void {
    if (this.activeSubmenu === menu) {
      this.activeSubmenu = null;
    } else {
      this.activeSubmenu = menu;
    }
  }

  get puedeVerSolicitudesPendientes(): boolean {
    return this.api.user?.IdRol == 400;
  }

  get puedeVerFacturacionInterna(): boolean {
    return this.api.user?.IdRol == 400 || this.api.user?.IdRol == 415;
  }

  get puedeVerPendientesRevision(): boolean {
    return this.api.user?.IdRol == 400 || this.api.user?.IdRol == 415;
  }




  flyoutMenu: string | null = null;
  flyoutTop = 0;
  tooltipLabel: string | null = null;
  tooltipTop = 0;
  private flyoutCloseTimer: any;

  openFlyout(event: MouseEvent, menuId: string): void {
    if (!this.sidebarCollapsed) return;
    clearTimeout(this.flyoutCloseTimer);
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    this.flyoutMenu = menuId;
    this.flyoutTop = Math.max(12, Math.min(rect.top, window.innerHeight - 560));
    this.tooltipLabel = null;
  }

  showTooltip(event: MouseEvent, label: string): void {
    if (!this.sidebarCollapsed) return;
    clearTimeout(this.flyoutCloseTimer);
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    this.tooltipLabel = label;
    this.tooltipTop = rect.top + rect.height / 2;
    this.flyoutMenu = null;
  }

  scheduleFlyoutClose(): void {
    clearTimeout(this.flyoutCloseTimer);
    this.flyoutCloseTimer = setTimeout(() => {
      this.flyoutMenu = null;
      this.tooltipLabel = null;
    }, 170);
  }

  cancelFlyoutClose(): void {
    clearTimeout(this.flyoutCloseTimer);
  }

  closeFlyout(): void {
    clearTimeout(this.flyoutCloseTimer);
    this.flyoutMenu = null;
    this.tooltipLabel = null;
  }


  get esRolPqr(): boolean {
    return Number(this.api.user?.IdRol) === 500;
  }

  get puedeVerPqr(): boolean {
    return this.esRolPqr
  }

  @HostListener('document:keydown.escape')
  onEscape(): void { this.closeFlyout(); }



}